import React from 'react';
import PropTypes from 'prop-types';
import Button from '@adsk/alloy-react-button';
import { useLocale } from '@adsk/alloy-react-helpers';

const CreateProjectFooter = ({
  createDisabled,
  isSaving,
  onCancelClick,
  onCreateClick,
}) => {
  const { T } = useLocale(({ locale }) => require(`../i18n/${locale}.json`));

  return (
    <>
      <Button
        data-testid="ProjectModal_cancel_button"
        onClick={onCancelClick}
        style={{
          minWidth: '40px',
          marginRight: '16px',
        }}
        variant={Button.VARIANTS.TERTIARY}
        disabled={isSaving}
      >
        {T.translate('FOOTER_CANCEL_BUTTON')}
      </Button>
      <Button
        data-testid="ProjectModal_create_button"
        disabled={createDisabled}
        loading={isSaving}
        onClick={onCreateClick}
        variant={Button.VARIANTS.PRIMARY}
      >
        {T.translate('FOOTER_CONFIRM_BUTTON')}
      </Button>
    </>
  );
};

CreateProjectFooter.propTypes = {
  createDisabled: PropTypes.bool.isRequired,
  isSaving: PropTypes.bool.isRequired,
  onCancelClick: PropTypes.func.isRequired,
  onCreateClick: PropTypes.func.isRequired,
};

export default CreateProjectFooter;
